import React from 'react'

export default function Top() {
    return (
        <div id="top">
            <h1>Leland Thomas Rogers</h1>
        </div>
    )
}
